import { Briefcase, Phone, Target, User } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Card, CardContent } from '../ui/card';

const Row = ({ icon: Icon, label, value, testId }) => (
    <div className="flex gap-3">
        <Icon className="mt-0.5 h-4 w-4 shrink-0 text-sky-600" />
        <div>
            <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{label}</p>
            <p className="text-sm" data-testid={testId}>{value}</p>
        </div>
    </div>
);

export const ScenarioBrief = ({ scenario }) => (
    <Card className="border-sky-200 dark:border-sky-800" data-testid="eeoc-scenario-brief">
        <CardContent className="space-y-4 p-5">
            <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-sky-600">Scenario brief</p>
                <h3 className="mt-1 text-base font-semibold" data-testid="eeoc-scenario-title">{scenario.title}</h3>
            </div>
            <Row icon={Phone} label="Setting" value={scenario.setting} />
            <Row icon={Briefcase} label="Role" value={scenario.role} />
            <Row icon={User} label="Candidate" value={scenario.persona} />
            <Row icon={Target} label="Your objective" value={scenario.objective} testId="eeoc-scenario-objective" />
            <div>
                <p className="mb-2 text-[11px] uppercase tracking-wide text-muted-foreground">Rules being evaluated</p>
                <div className="flex flex-wrap gap-1.5">
                    {scenario.rules.map((r) => (
                        <Badge key={r.id} variant="outline" className="text-xs font-normal">{r.title}</Badge>
                    ))}
                </div>
            </div>
        </CardContent>
    </Card>
);
